// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * Traffic Config API
 * traffic-config-api manages traffic configuration for the Aura platform.
 *
 * The version of the OpenAPI document: 1.0
 * Contact: team-aura-infra@neotechnology.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 *
 * @export
 */
export const TrafficconfigAzurePrivateEndpointState = {
  AzurePrivateEndpointStatePending: 'pending',
  AzurePrivateEndpointStateApproved: 'approved',
} as const;
export type TrafficconfigAzurePrivateEndpointState =
  (typeof TrafficconfigAzurePrivateEndpointState)[keyof typeof TrafficconfigAzurePrivateEndpointState];

export function instanceOfTrafficconfigAzurePrivateEndpointState(
  value: any,
): boolean {
  for (const key in TrafficconfigAzurePrivateEndpointState) {
    if (
      Object.prototype.hasOwnProperty.call(
        TrafficconfigAzurePrivateEndpointState,
        key,
      )
    ) {
      if (
        TrafficconfigAzurePrivateEndpointState[
          key as keyof typeof TrafficconfigAzurePrivateEndpointState
        ] === value
      ) {
        return true;
      }
    }
  }
  return false;
}

export function TrafficconfigAzurePrivateEndpointStateFromJSON(
  json: any,
): TrafficconfigAzurePrivateEndpointState {
  return TrafficconfigAzurePrivateEndpointStateFromJSONTyped(json, false);
}

export function TrafficconfigAzurePrivateEndpointStateFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): TrafficconfigAzurePrivateEndpointState {
  return json as TrafficconfigAzurePrivateEndpointState;
}

export function TrafficconfigAzurePrivateEndpointStateToJSON(
  value?: TrafficconfigAzurePrivateEndpointState | null,
): any {
  return value as any;
}

export function TrafficconfigAzurePrivateEndpointStateToJSONTyped(
  value: any,
  ignoreDiscriminator: boolean,
): TrafficconfigAzurePrivateEndpointState {
  return value as TrafficconfigAzurePrivateEndpointState;
}
